// Not / bildirim / e-posta metinleri v-html ile gösteriliyordu: bir not ya da
// içe aktarılmış alan içine yazılan <img onerror=...> açan kişinin
// tarayıcısında çalışıyor, localStorage'daki oturum token'ını ele
// geçirebiliyordu (stored XSS).
//
// Metnin tamamı kaçışlanır, sonra sadece özniteliksiz basit biçimlendirme
// etiketleri geri açılır. Öznitelik olmadığı için olay işleyicisi / bağlantı
// eklenemez. Düz metin notlar ve eski kayıtlardaki <br>, <b> gibi etiketler
// aynı görünür.
const ALLOWED = "br|b|strong|i|em|u|p|div|span|ul|ol|li";
const ALLOWED_TAG = new RegExp("&lt;(/?)(" + ALLOWED + ")\\s*/?&gt;", "gi");

const ESCAPES = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};

export function escapeHtml(value) {
  return String(value == null ? "" : value).replace(
    /[&<>"']/g,
    c => ESCAPES[c]
  );
}

export default function safeHtml(value) {
  return escapeHtml(value).replace(ALLOWED_TAG, (m, slash, tag) => {
    return "<" + slash + tag.toLowerCase() + ">";
  });
}
